import React from 'react';
import Link from 'next/link';
import Modal from '@common/modal';
import { RouteUrl } from '@utils/routeUtil';

import classnames from 'classnames/bind';
import styles from './saveCompleteModal.module.scss';
const cx = classnames.bind(styles);

interface SaveCompleteModalProps {
  visible: boolean;
}

const SaveCompleteModal = ({ visible }: SaveCompleteModalProps) => {
  return (
    <Modal visible={visible}>
      <div className={cx('layer')}>
        <em className={cx('title')}>역검 응시 결과 저장이 완료되었어요!</em>

        <p className={cx('desc')}>
          저장된 역검 결과는 잡다 사이트에서 확인할 수 있어요.
          <br />
          저장된 결과는 다른 기업에 지원할 때 불러와
          <br />
          사용할 수 있어요.
        </p>

        <Link href={RouteUrl.ACCA_RESULTS} legacyBehavior>
          <a className={cx('btn')} role="button">
            결과 확인하기
          </a>
        </Link>
      </div>
    </Modal>
  );
};

export default SaveCompleteModal;
